import qs from 'query-string';
import { get, post, put, del } from './baseApi';

export const ReportTemplateApi = {
    fetch: (query, options) => get(`/reports/templates?${qs.stringify(query)}`, options),
    fetchById: (id) => get(`/reports/templates/${id}`),
    create: (data) => post('/reports/templates', data),
    update: (id, data) => put(`/reports/templates/${id}`, data),
    delete: (id) => del(`/reports/templates/${id}`),
    createImage: (data) => post(`/reports/templates/images`, data),
};
